module.exports = __webpack_public_path__ + "static/media/instagram.875597c9.png";